module.exports = __webpack_public_path__ + "media/images/goats/Sticky tail and vulval discharge.jpg";